import { render } from "./withdrawalHistory.vue?vue&type=template&id=a35f5812"
import script from "./withdrawalHistory.vue?vue&type=script&lang=js"
export * from "./withdrawalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__